<button type="button" class="close" aria-label="Close">
  <icon-times [style.width.px]="12" aria-hidden="true"></icon-times>
</button>
